import RequestPageTwo from "./RequestPageTwo";

const RequestOngoingReq = () => {
    return (
        <RequestPageTwo title="Request Ongoing Rquests"
            fetchUrl="/get-ongoing-project-requests"
            editEndpoint="update-ongoing-project-requests"
            deleteEndpoint="ongoing-project-requests"
            statusEndpoint="update-ongoing-project-requests" />
    );
}

export default RequestOngoingReq;
